import { Badge, Flex, Label } from "@aws-amplify/ui-react";
import { useTranslation } from "react-i18next";

interface PlacePropertyBadgeProps {
    propertyEnum: string;
}

const PlacePropertyBadge: React.FC<PlacePropertyBadgeProps> = ({ propertyEnum }) => {
    const { t } = useTranslation();

    return (
        <Badge
            key={propertyEnum}
            id={propertyEnum}
            size="small"
            className="noselect place-property-badge nopointer"
        >
            <Flex>
                <Label whiteSpace="nowrap">
                    {t('place.properties.' + propertyEnum)}
                </Label>
            </Flex>
        </Badge>
    );
};

export default PlacePropertyBadge; 